
import * as handlebars_family from "../../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("modal/part/invitation_msisdn",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
export default TPL;